import { Box, Checkbox, TextField, Typography, type CheckboxProps, type TextFieldProps } from '@mui/material';
import { useId, type ReactNode } from 'react';

export function D365FormRow({ label, required = false, align = 'center', htmlFor, children }: { label: ReactNode; required?: boolean; align?: 'center' | 'start'; htmlFor?: string; children: ReactNode }) {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(125px, 42%) minmax(0, 1fr)', sm: '180px minmax(0, 1fr)' }, gap: 1.5, alignItems: align }}>
      <Typography component="label" htmlFor={htmlFor} sx={{ pt: align === 'start' ? 1.25 : 0, lineHeight: 1.3 }}>
        {label}{required && <Box component="span" aria-hidden="true" sx={{ color: 'error.main', ml: 0.5 }}>*</Box>}
      </Typography>
      <Box sx={{ minWidth: 0 }}>{children}</Box>
    </Box>
  );
}

export function D365TextField({ label, required, multiline, ...props }: TextFieldProps) {
  const generatedId = useId();
  const id = props.id ?? generatedId;
  return (
    <D365FormRow label={label} required={required} align={multiline ? 'start' : 'center'} htmlFor={id}>
      <TextField {...props} id={id} required={required} multiline={multiline} placeholder={props.placeholder ?? '---'} sx={d365ControlSx} />
    </D365FormRow>
  );
}

export function D365Checkbox({ label, ...props }: CheckboxProps & { label: ReactNode }) {
  return (
    <D365FormRow label={label}>
      <Checkbox {...props} sx={{ p: 0.75 }} />
    </D365FormRow>
  );
}

export const d365ControlSx = {
  width: '100%',
  '& .MuiOutlinedInput-root': { bgcolor: '#f3f2f1', borderRadius: 1, minHeight: 42 },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#8a8886' },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main', borderWidth: 1 },
};
